import { ROLES, USERS } from "../../constants/strings";
import { TEMPLATES, VERSION } from "../../constants/webapp";
import { useRolesForm } from "../roles/useRolesForm";
import { useTemplatesForm } from "../templates/useTemplatesForm";
import { useUsersForm } from "../users/useUsersForm";
import { useVersionForm } from "../version/useVersionForm";

export const formHooks = {
  [ROLES]: useRolesForm,
  [USERS]: useUsersForm,
  [VERSION]: useVersionForm,
  [TEMPLATES]: useTemplatesForm,
};
